var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepertoireLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#c3beaf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#5d3c05",
    fillOpacity: 0.501961,
    points: "-16,256 5,-16 79,259"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8f6ff",
    fillOpacity: 0.501961,
    points: "202,271 26,14 271,22"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cedff1",
    fillOpacity: 0.501961,
    points: "177,237 33,242 34,28"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b56c00",
    fillOpacity: 0.501961,
    points: "198,270 264,267 271,77"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#752f00",
    fillOpacity: 0.501961,
    points: "41,243 159,271 176,239"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#915a06",
    fillOpacity: 0.501961,
    points: "35,-5 -16,2 30,190"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8b4700",
    fillOpacity: 0.501961,
    points: "-8,14 93,-16 86,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ba7e0c",
    fillOpacity: 0.501961,
    points: "268,-2 271,34 154,-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "104,-16 241,26 82,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5d471f",
    fillOpacity: 0.501961,
    points: "-16,240 34,109 36,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000400",
    fillOpacity: 0.501961,
    points: "61,189 61,170 48,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eaf1f7",
    fillOpacity: 0.501961,
    points: "218,68 266,88 201,255"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9f680d",
    fillOpacity: 0.501961,
    points: "75,256 249,271 164,240"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#424a3f",
    fillOpacity: 0.501961,
    points: "54,202 83,251 75,213"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a27f42",
    fillOpacity: 0.501961,
    points: "35,157 -16,14 33,-12"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#afb5b7",
    fillOpacity: 0.501961,
    points: "39,67 101,37 195,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5e3d10",
    fillOpacity: 0.501961,
    points: "2,126 22,271 -16,255"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#aeb5b3",
    fillOpacity: 0.501961,
    points: "45,80 149,109 15,111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5fbfe",
    fillOpacity: 0.501961,
    points: "163,149 38,153 97,170"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eff7fd",
    fillOpacity: 0.501961,
    points: "135,-11 271,88 254,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9fcfc5",
    fillOpacity: 0.501961,
    points: "21,219 12,192 30,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a521e",
    fillOpacity: 0.501961,
    points: "-16,243 80,271 109,241"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdffff",
    fillOpacity: 0.501961,
    points: "145,236 205,249 202,233"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2bbbc",
    fillOpacity: 0.501961,
    points: "138,125 45,156 25,131"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1a6a7",
    fillOpacity: 0.501961,
    points: "71,85 99,100 147,86"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#edf2f5",
    fillOpacity: 0.501961,
    points: "70,216 150,195 58,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6c7c64",
    fillOpacity: 0.501961,
    points: "31,179 40,197 73,190"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9ea3a4",
    fillOpacity: 0.501961,
    points: "190,125 109,127 146,138"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#edf2f5",
    fillOpacity: 0.501961,
    points: "88,90 133,103 44,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#959a9b",
    fillOpacity: 0.501961,
    points: "167,178 195,167 128,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#919697",
    fillOpacity: 0.501961,
    points: "67,54 104,44 35,44"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#959a9b",
    fillOpacity: 0.501961,
    points: "191,43 157,53 128,44"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5fbfe",
    fillOpacity: 0.501961,
    points: "33,111 118,113 62,128"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7fdff",
    fillOpacity: 0.501961,
    points: "167,59 125,48 93,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#939899",
    fillOpacity: 0.501961,
    points: "132,84 159,94 191,85"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9da1a0",
    fillOpacity: 0.501961,
    points: "139,168 93,181 52,169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#959896",
    fillOpacity: 0.501961,
    points: "136,209 67,210 101,219"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1f7fb",
    fillOpacity: 0.501961,
    points: "115,75 37,66 34,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#85551a",
    fillOpacity: 0.501961,
    points: "21,49 34,95 33,3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f3f9fe",
    fillOpacity: 0.501961,
    points: "224,85 153,64 91,82"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#52452a",
    fillOpacity: 0.501961,
    points: "47,151 -10,123 22,151"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#969b9c",
    fillOpacity: 0.501961,
    points: "115,145 146,153 179,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8eef5",
    fillOpacity: 0.501961,
    points: "33,47 34,16 149,38"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f9fd",
    fillOpacity: 0.501961,
    points: "203,211 205,187 126,202"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f3feff",
    fillOpacity: 0.501961,
    points: "35,212 54,205 35,198"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b6801c",
    fillOpacity: 0.501961,
    points: "269,5 245,30 255,35"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5fbff",
    fillOpacity: 0.501961,
    points: "175,167 113,151 217,149"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9ec6b4",
    fillOpacity: 0.501961,
    points: "2,153 17,164 16,141"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c3cdcc",
    fillOpacity: 0.501961,
    points: "85,145 35,173 34,104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#949999",
    fillOpacity: 0.501961,
    points: "130,186 157,194 184,187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1f8fd",
    fillOpacity: 0.501961,
    points: "200,125 89,124 146,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a27827",
    fillOpacity: 0.501961,
    points: "-16,12 86,-16 86,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#929693",
    fillOpacity: 0.501961,
    points: "168,224 141,233 192,231"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a4762f",
    fillOpacity: 0.501961,
    points: "42,-16 -16,0 -3,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1a6a8",
    fillOpacity: 0.501961,
    points: "163,114 195,103 130,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1f7fb",
    fillOpacity: 0.501961,
    points: "197,108 144,111 225,131"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9ea2a1",
    fillOpacity: 0.501961,
    points: "196,207 132,209 163,217"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#675535",
    fillOpacity: 0.501961,
    points: "-12,134 44,155 15,118"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6ecf1",
    fillOpacity: 0.501961,
    points: "256,43 123,-16 119,42"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#949b97",
    fillOpacity: 0.501961,
    points: "45,122 86,131 38,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c4c9cc",
    fillOpacity: 0.501961,
    points: "200,44 199,164 233,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ebf0f1",
    fillOpacity: 0.501961,
    points: "59,187 103,172 147,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a77a3c",
    fillOpacity: 0.501961,
    points: "160,239 252,271 78,259"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5a9a8",
    fillOpacity: 0.501961,
    points: "65,193 142,192 105,181"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a7adaa",
    fillOpacity: 0.501961,
    points: "74,220 78,235 127,231"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecf0f2",
    fillOpacity: 0.501961,
    points: "90,132 112,144 50,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e2e7ea",
    fillOpacity: 0.501961,
    points: "227,188 271,70 189,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8e9291",
    fillOpacity: 0.501961,
    points: "159,150 192,146 171,142"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#789b85",
    fillOpacity: 0.501961,
    points: "15,228 28,212 23,242"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a390f",
    fillOpacity: 0.501961,
    points: "54,176 59,188 64,173"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#969a98",
    fillOpacity: 0.501961,
    points: "82,149 104,143 128,150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2f5f4",
    fillOpacity: 0.501961,
    points: "163,240 108,239 136,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5b5145",
    fillOpacity: 0.501961,
    points: "49,232 107,258 96,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#989c9b",
    fillOpacity: 0.501961,
    points: "220,60 230,70 193,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c6d0dd",
    fillOpacity: 0.501961,
    points: "42,227 47,212 80,243"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5c5352",
    fillOpacity: 0.501961,
    points: "53,236 23,225 41,224"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1f3f6",
    fillOpacity: 0.501961,
    points: "40,235 60,240 35,242"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2f7f9",
    fillOpacity: 0.501961,
    points: "247,96 176,66 195,89"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e9ecec",
    fillOpacity: 0.501961,
    points: "116,214 75,227 150,227"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8edef",
    fillOpacity: 0.501961,
    points: "43,61 104,59 70,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5a9a7",
    fillOpacity: 0.501961,
    points: "187,27 165,34 151,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e9f0f4",
    fillOpacity: 0.501961,
    points: "107,132 142,144 185,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9acaa",
    fillOpacity: 0.501961,
    points: "119,221 96,232 159,233"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#898c8a",
    fillOpacity: 0.501961,
    points: "44,61 76,62 52,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#704b1a",
    fillOpacity: 0.501961,
    points: "-16,193 30,193 22,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eff3f7",
    fillOpacity: 0.501961,
    points: "213,225 176,211 150,224"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0d3d4",
    fillOpacity: 0.501961,
    points: "252,83 222,116 219,186"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9fa3a2",
    fillOpacity: 0.501961,
    points: "119,42 137,51 88,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9fa3a2",
    fillOpacity: 0.501961,
    points: "64,86 130,84 95,95"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8d908f",
    fillOpacity: 0.501961,
    points: "173,192 191,182 192,190"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6ebee",
    fillOpacity: 0.501961,
    points: "44,169 61,150 129,166"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b21",
    fillOpacity: 0.501961,
    points: "59,205 59,215 70,212"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#919d96",
    fillOpacity: 0.501961,
    points: "37,142 77,148 39,153"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#989c9a",
    fillOpacity: 0.501961,
    points: "54,36 72,31 81,36"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4f544c",
    fillOpacity: 0.501961,
    points: "42,184 48,183 54,203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a9d9c",
    fillOpacity: 0.501961,
    points: "99,66 121,58 150,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#edf2f7",
    fillOpacity: 0.501961,
    points: "48,131 63,145 42,145"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ebf0f3",
    fillOpacity: 0.501961,
    points: "185,172 129,179 182,187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#948d68",
    fillOpacity: 0.501961,
    points: "20,84 52,111 9,100"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9ca09f",
    fillOpacity: 0.501961,
    points: "139,61 187,60 163,68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepertoireLow);
export default __webpack_public_path__ + "static/media/repertoire_low.075269f3b2a079f50808502cd8d2fd2f.svg";
export { ForwardRef as ReactComponent };